class ProductInventory extends HTMLElement {
  connectedCallback() {
    this.render();
  }

  render() {
    const route = this.dataset.route || '';
    const available = this.dataset.variantAvailable === 'true';
    const statusEl = this.querySelector('.js-inventory-notice');

    if (!statusEl) return;

    this.classList.remove(
      'product-inventory--in-stock',
      'product-inventory--out-of-stock',
      'product-inventory--drop-shipped'
    );

    if (route === 'Dropship') {
      statusEl.innerHTML = this.dataset.textDropShipped || 'Drop Shipped';
      this.classList.add('product-inventory--drop-shipped');
    } else if (available) {
      statusEl.textContent = this.dataset.textInStock || 'In stock';
      this.classList.add('product-inventory--in-stock');
    } else {
      statusEl.textContent = this.dataset.textOutOfStock || 'Sold out';
      this.classList.add('product-inventory--out-of-stock');
    }
  }
}

customElements.define('product-inventory', ProductInventory);